
export function padStart(str, targetLength, padString) {
    let truncatedTargetLength = targetLength >> 0
    padString = String(typeof padString !== 'undefined' ? padString : ' ')
    if (str.length >= truncatedTargetLength) {
        return String(str)
    } else {
        truncatedTargetLength = truncatedTargetLength - str.length
        if (truncatedTargetLength > padString.length) {
            padString += padString.repeat(truncatedTargetLength / padString.length)
        }
        return padString.slice(0, truncatedTargetLength) + String(str)
    }
}


// WEBPACK FOOTER //
// ./utilities/padStart.js